export default "__VITE_ASSET__DF_JFyp0__"